import styled from 'styled-components';

export const LoginLink = styled.a`
  border-width: 1px;
  border-style: solid;
  border-color: ${({theme, variant}) => variant === 'dark' ? theme.colors.gray300 : theme.colors.gray600};
  border-radius: 4px;
  padding: 0 24px;
  width: ${({type}) => type === 'hamburger-item' ? '140px' : 'auto'};
  height: 48px;
  line-height: 48px;
  font-size: 14px;
  text-align: center;
  color: ${({theme, variant}) => variant === 'dark' ? theme.colors.gray300 : theme.colors.gray600};
  background-color: ${({variant}) => variant === 'dark' ? 'rgba(255, 255, 255, 0)' : 'rgba(0, 0, 0, 0)'};
  transition: color 300ms, background-color 300ms, border-color 300ms;

  &:hover {
    color: ${({theme, variant}) => variant === 'dark' ? theme.colors.gray100 : theme.colors.gray900};
    border-color: ${({theme, variant}) => variant === 'dark' ? theme.colors.gray100 : theme.colors.gray900};
    background-color: ${({variant}) => variant === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'};
  }
`;
